import { memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Button } from 'basic-components';
import TimeService from 'dashboard-services/services/TimeService';

import parser from 'cron-parser';

import './Footer.scss';

const replaceDayOfWeek = cron => {
  const splitted = cron.split(" ")
  splitted[5] = splitted[5]
    ?.replace("/TUE", "/2")
    ?.replace("/WED", "/3")
    ?.replace("/THU", "/4")
    ?.replace("/FRI", "/5")
    ?.replace("/SAT", "/6")

  return splitted.join(" ")
}

const cancelMargin = { marginRight: "16px" }, UTC = "UTC"
const Footer = ({ onCancel, onSubmit, cron }) => {
  const MessageStore = useSelector(state => state.globalState.MessageStore)
  const getNextRun = useCallback(() => {
          try {
            const interval = parser.parseExpression(cron, { tz: UTC });
            return TimeService.getUserFormattedDateTime(interval.next(), UTC, "YYYY-MM-DD HH:mm")
          } catch(e) {
            MessageStore.error(e.message)
            return "";
          }
        }, [MessageStore, cron]),
        nextRun = useMemo(() => getNextRun(), [getNextRun]), // trick to not update the state (MessageStore) on useMemo
        copyCron = useCallback(() => {
          navigator.clipboard.writeText(cron)
            .then(() => MessageStore.success("Cron copied to clipboard."))
        }, [MessageStore, cron])
  return (
      <div className="cron-creator__footer">
        <div className="cron-creator__footer__expression">
          <div className="cron-creator__footer__expression__label">
            Cron expression
          </div>
          <div 
              className="cron-creator__footer__expression__value"
              onClick={copyCron}
          >
            {replaceDayOfWeek(cron)}
          </div>
        </div>
        <div className="cron-creator__footer__expression">
          <div className="cron-creator__footer__expression__label">
            Next run
          </div>
          <div className="cron-creator__footer__expression__value">
            <div className="cron-creator__footer__expression__value__date">
              {nextRun.split(" ")[0]}
            </div>
            <div className="cron-creator__footer__expression__value__time">
              {nextRun.split(" ")[1]}
            </div>
          </div>
        </div>
        <div className="cron-creator__footer__buttons">
          <Button 
              onClick={onCancel}
              size="small"
              style={cancelMargin}
              variant="text"
          >
            Cancel
          </Button>
          <Button
              onClick={onSubmit}
              size="small"
              type="submit"
          >
            Submit
          </Button>
        </div>
      </div>
    )
}

Footer.propTypes = {
  cron: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default memo(Footer)